import DataSourcesAPI from '../services/dataSources';
import { useFetch } from '../dataSources/hooks';

// TODO: (product) does the os should be const ?
export const useFetchOS = () => {
    const dataSourcesAPI = new DataSourcesAPI();
    return useFetch(dataSourcesAPI.getOS, false);
};
